import React from 'react';
import { VERSION, getAllVersions, getVersionChanges } from 'version';
import { Dialog, DialogContent } from 'shared/ui/Dialog';
import { cn } from 'shared/lib/cn';

export type ChangelogDialogProps = { open: boolean; onClose: () => void };

/** `getAllVersions()` (src/version.js) returns the changelog OLDEST first, so
 *  rendering it in that order would put the current release at the bottom of
 *  the scroller. This reverses a COPY before rendering — it never mutates the
 *  array version.js hands back. */
export function ChangelogDialog({ open, onClose }: ChangelogDialogProps) {
  const versions: string[] = [...getAllVersions()].reverse();

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
      <DialogContent title="What's new" className="max-w-2xl">
        <div className="max-h-[60vh] overflow-auto pr-2">
          {versions.map((v) => {
            const current = v === VERSION;
            return (
              <section
                key={v}
                data-testid={`version-${v}`}
                data-current={current}
                className={cn(
                  'border-b border-hairline/10 py-3 last:border-0',
                  current && 'rounded-[var(--radius-2)] bg-brand/5 px-3',
                )}
              >
                <h3 className={cn('font-display text-sm font-semibold', current ? 'text-brand-strong' : 'text-ink')}>
                  v{v}{current ? ' · current' : ''}
                </h3>
                <ul className="mt-1 flex flex-col gap-0.5">
                  {getVersionChanges(v).map((change: string, i: number) => (
                    <li key={i} className="font-body text-xs text-ink-muted">• {change}</li>
                  ))}
                </ul>
              </section>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
